import React, {Component} from "react";
import NewInstitution from "./NewInstitutionView";
import {InstitutionService} from "../../../../service/maintenance/institution/InstitutionService";
import {Button} from "primereact/button";
import {
    INSERT_CONTACT_ROUTE,
    INSERT_INSTITUTION_ROUTE,
    INSERT_SIGN_ROUTE,
    MAINTENANCE_INSTITUTIONS_ROUTE
} from "../../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import {isValidData} from "../../../../utils/validator/Fields";
import {replaceDiacriticsUni, deleteSpecialChars, deleteNonNumericPint} from "../../../../utils/formatters/Accent";
import ContextMenu from "../../../../components/contextMenu";


export default class NewInstitutionContainer extends Component {
    constructor(props) {
        super(props);
        let today = new Date();

        this.institutionService = new InstitutionService();

        this.selectedIndexSteps = this.selectedIndexSteps.bind(this);
        this.getCatalogsInstitution = this.getCatalogsInstitution.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveDataInstitution = this.saveDataInstitution.bind(this);
        this.saveDataAlphaNum = this.saveDataAlphaNum.bind(this);
        this.saveDataPint = this.saveDataPint.bind(this);
        this.saveDataCheckInstitution = this.saveDataCheckInstitution.bind(this);
        this.contactActionTemplate = this.contactActionTemplate.bind(this);
        this.deleteSignActionTemplate = this.deleteSignActionTemplate.bind(this);
        this.openAddContact = this.openAddContact.bind(this);
        this.openAddSigns = this.openAddSigns.bind(this);
        this.insertInstitution = this.insertInstitution.bind(this);
        this.deleteContact = this.deleteContact.bind(this);
        this.deleteSign = this.deleteSign.bind(this);
        this.goNextStep = this.goNextStep.bind(this);
        this.goPreviousStep = this.goPreviousStep.bind(this);

        this.state = {
            isEditableRS: false,
            today: today,
            newIndex: '',
            isLoading: true,
            returnPath: this.props.location.state.returnPath,
            activeIndex: this.props.location.state.activeIndex ? this.props.location.state.activeIndex : 0,
            catalogs: this.getCatalogsInstitution(),
            catInstitutions:[],
            items: [
                {
                    label: 'Institución',
                },
                {
                    label: 'Medios de Comunicación',
                },
                {
                    label: 'Firmas Autorizadas',
                },
                {
                    label: 'Documentación',
                }
            ],
            dialogSign: {},
            institution:
                this.props.location.state.institution ? this.props.location.state.institution :
                    {
                        catInstitution: '',
                        nombreCorto:'',
                        catTypeLoan: '',
                        catRole: '',
                        catInstrument: '',
                        catStatus: '',
                        catRoleType: '',
                        catSignType: '',
                        catIdType: '',
                        catIdClientGss: '',
                        catIdCounterpartGss: '',
                        contact: [{}],
                        sign: [{}],
                        escrituraFec: today,
                        regPubFec: today,
                        powerDate: today,
                    },
            contactList: this.props.location.state.contactList ? this.props.location.state.contactList : [],
            signList: this.props.location.state.signList ? this.props.location.state.signList : [],
            requiredFields: ['catInstitution', 'nombreCorto', 'catTypeLoan', 'catInstrument', 'catRole', 'catStatus',
                'razonSocial', 'rfc', 'numEscCon', 'recPubComer', 'powerNumber'],
            requiredFieldsFis: ['fisCalle', 'fisColonia', 'fisCP', 'fisCiudad', 'fisEstado', 'fisPais',],
            requiredFieldsCorr: ['corrCalle', 'corrColonia', 'corrCP', 'corrCiudad', 'corrEstado', 'corrPais'],
            requiredFieldsDoc: ['idInst', 'folioInst'],
        }
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: MAINTENANCE_INSTITUTIONS_ROUTE,
            message: message,
        });
    }

    selectedIndexSteps(event, newIndexAux) {
        let indexAux = this.state.activeIndex;
        let newIndex = !isNaN(event.index) ? event.index : newIndexAux;

        switch (indexAux) {
            case 0:
                if (!isValidData(this.state.requiredFields, this.state.institution)) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe llenar los campos requeridos correctamente'
                    });
                } else {
                    indexAux = newIndex;
                }
                break;
            case 1:
                if (!isValidData(this.state.requiredFieldsFis, this.state.institution)) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe llenar todos los campos de dirección fiscal'
                    });
                } else if (!isValidData(this.state.requiredFieldsCorr, this.state.institution)) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe llenar todos los campos de dirección correspondencia'
                    });
                } else if (this.state.contactList.length === 0) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe al menos tener un contacto.'
                    });
                } else {
                    indexAux = newIndex;
                }
                break;
            case 2:
                if (this.state.signList.length === 0) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe al menos tener una firma autorizada.'
                    });
                } else {
                    indexAux = newIndex;
                }
                break;
            case 3:
                if (!isValidData(this.state.requiredFieldsDoc, this.state.institution)) {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: 'Debe llenar los campos requeridos correctamente'
                    });
                } else {
                    indexAux = newIndex;
                }
                break;
            default:
                break;
        }
        this.setState({activeIndex: indexAux,});
    }

    goNextStep(){
        this.selectedIndexSteps("", this.state.activeIndex + 1);
    }

    goPreviousStep(){
        this.selectedIndexSteps("", this.state.activeIndex - 1);
    }

    openAddContact(rowdata) {
        this.props.history.push({
            pathname: INSERT_CONTACT_ROUTE,
            state: {
                returnPath: INSERT_INSTITUTION_ROUTE,
                actionScreen: 'Insertar',
                institution: this.state.institution,
                contactList: this.state.contactList,
                signList: this.state.signList,
                roleType: this.state.catalogs[2],
                contactType: this.state.catalogs[1],
                contactData: rowdata,
            },
        });
    }

    openAddSigns() {
        this.props.history.push({
            pathname: INSERT_SIGN_ROUTE,
            state: {
                returnPath: INSERT_INSTITUTION_ROUTE,
                actionScreen: 'Insertar',
                institution: this.state.institution,
                contactList: this.state.contactList,
                signList: this.state.signList,
                signType: this.state.catalogs[3],
                idType: this.state.catalogs[4],
            },
        });
    }

    deleteContact(rowData) {
        this.setState({
            contactList: this.state.contactList.filter((val, i) =>
                val !== rowData
            )
        });
    }

    deleteSign(rowData) {
        this.setState({
            signList: this.state.signList.filter((val, i) =>
                val !== rowData
            )
        });
    }

    contactActionTemplate(rowData, column) {
        let optionsMenu = [
            {label: "Editar ", action: () => this.openAddContact(rowData)},
            {label: "Eliminar", action: () => this.deleteContact(rowData)}
        ];
        return (
            <ContextMenu menuOptions={optionsMenu}/>
        );
    }

    deleteSignActionTemplate(rowData) {
        return <Button type="button"
                       iconPos="left"
                       label="Eliminar"
                       style={{marginRight: '.5em'}}
                       onClick={() => this.deleteSign(rowData)}
        />;
    }

    getCatalogsInstitution() {
        this.loading();
        return this.institutionService.getCatalogsInstitution().then(res => {
            this.setState({
                isLoading: false,
            });
            if (res.error !== '') {
                this.growl.show({severity: 'error', summary: 'Error.', detail: res.error});
            } else {
                let catInst = res.payload[0].filter(e=> !e.registered);
                /**
                 * Diferenciación entre Fideicomiso BBVA y Banamex:
                 * Si el catálogo de intituciones trae en su primer elemento la razón social, NO es editable
                 */
                let isEditableRaS = catInst.length === 0 || catInst[0]['NomInstFinan'] === undefined;
                this.setState({
                    catalogs: res.payload,
                    catInstitutions: catInst,
                    isEditableRS: isEditableRaS,
                });
            }
        });
    }

    saveDataInstitution(event) {
        let {name, value} = event.target;
        let institution = this.state.institution;
        if (value === null){
            value = "";
        }
        institution[name] = value;
        if (name === 'catInstitution' && value.NomInstFinan !== undefined){
            institution['razonSocial'] = value.NomInstFinan;
        }
        if (name === 'catInstitution'){
            institution['nombreCorto'] = value.NomInstFinanCorto;
        }
        this.setState({institution: institution,})
    }
    saveDataAlphaNum(event){
        const {name, value} = event.target;
        let institution = this.state.institution;
        institution[name] = deleteSpecialChars(replaceDiacriticsUni(value));
        this.setState({institution: institution,})
    }

    saveDataPint(event){
        const {name, value} = event.target;
        let institution = this.state.institution;
        institution[name] = deleteNonNumericPint(value);
        this.setState({institution: institution,})
    }

    saveDataCheckInstitution(event) {
        const {name, checked} = event.target;
        let institution = this.state.institution;
        institution[name] = checked;
        this.setState({institution: institution,})
    }

    insertInstitution() {
        if (!isValidData(this.state.requiredFields, this.state.institution)) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Debe llenar los campos requeridos correctamente'
            });
        } else if (this.state.contactList.length === 0) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Agregar por lo menos un medio de contacto'
            });
        } else if (this.state.signList.length === 0) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Agregar por lo menos una firma'
            });
        } else if (!isValidData(this.state.requiredFieldsDoc, this.state.institution)) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Debe llenar los campos requeridos correctamente'
            });
        } else {
            this.institutionService.updateInstitution(
                this.state.institution,
                this.state.contactList,
                this.state.signList,
                false
            ).then(res => {
                if (res.error !== '') {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: res.error});
                } else {
                    let messageObj = {};
                    messageObj['severity'] = 'success';
                    messageObj['sumary'] = 'Éxito';
                    messageObj['detail'] = res.message === 'Success' ?
                        'Se ha actualizado su solicitud con éxito' :
                        res.message;
                    this.handleReturnButton(messageObj);
                }
            });
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        return (
            <NewInstitution
                isLoading={this.state.isLoading}
                displayDialogContacts={this.state.displayDialogContacts}
                displayDialogSigns={this.state.displayDialogSigns}
                closeDialogContacts={this.closeDialogContacts}
                closeDialogSigns={this.closeDialogSigns}
                messagesGrowl={messagesGrowl}
                insertInstitution={this.insertInstitution}
                handleReturnButton={this.handleReturnButton}
                contactActionTemplate={this.contactActionTemplate}
                deleteSignActionTemplate={this.deleteSignActionTemplate}
                saveDataInstitution={this.saveDataInstitution}
                saveDataAlphaNum={this.saveDataAlphaNum}
                saveDataPint={this.saveDataPint}
                saveDataCheckInstitution={this.saveDataCheckInstitution}
                activeIndex={this.state.activeIndex}
                items={this.state.items}
                selectedIndexSteps={this.selectedIndexSteps}
                institution={this.state.institution}
                businessName={this.state.catInstitutions}
                catInstitution={this.state.institution.catInstitution}
                typeLoan={this.state.catalogs[9]}
                catTypeLoan={this.state.institution.catTypeLoan}
                role={this.state.catalogs[5]}
                catRole={this.state.institution.catRole}
                instrument={this.state.catalogs[6]}
                catInstrument={this.state.institution.catInstrument}
                status={this.state.catalogs[10]}
                catStatus={this.state.institution.catStatus}
                contactType={this.state.catalogs[1]}
                catContactType={this.state.institution.catContactType}
                roleType={this.state.catalogs[2]}
                catRoleType={this.state.institution.catRoleType}
                signType={this.state.catalogs[3]}
                catSignType={this.state.institution.catSignType}
                idType={this.state.catalogs[4]}
                catIdType={this.state.institution.catIdType}
                idClientGss={this.state.catalogs[7]}
                catIdClientGss={this.state.institution.catIdClientGss}
                idCounterpartGss={this.state.catalogs[8] !== undefined ? this.state.catalogs[8]['contraparte'] : []}
                catIdCounterpartGss={this.state.institution.catIdCounterpartGss}
                contact={this.state.institution.contact}
                sign={this.state.institution.sign}
                contactList={this.state.contactList}
                signList={this.state.signList}
                today={this.state.today}
                isEditableRS={this.state.isEditableRS}
                openAddContact={this.openAddContact}
                openAddSigns={this.openAddSigns}
                goNextStep={this.goNextStep}
                goPreviousStep={this.goPreviousStep}
                loading={this.loading}
            />)
    }
}